import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { protectedResources } from "../app/authConfig";
import { LEAD_TYPE_PATHS } from "../pages/constants";
import { handleDeleteCardService } from "../pages/leads-management/service/LeadService";
import { getAllLeads, getHotLeads, getWarmLeads, getInterestedLeads } from "../slices/leads/leadManagementSlice";
import { useContext } from "react";
import { TodosContext } from "../context";

export const useHandleConfirm = (
  selectedLead: any,
  handleCloseModal: () => void,
  setIsLoading: (loading: boolean) => void
) => {
  const navigate = useNavigate();
  const locationURL = useLocation();
  const dispatch = useDispatch();
  const { addAlert } = useContext(TodosContext);
  
  const handleConfirm = () => {
    handleCloseModal();

    const path = locationURL.pathname.split("/")[2] as LEAD_TYPE_PATHS;

    const defaultParams = {
      PageNumber: 1,
      SearchText: "",
      SortOrder: 1,
      PageSize: 10,
      OrderBy: "",
      ParameterOne: "Requested,Rejected",
      ParameterTwo: "",
      ParameterThree: "Requested,Rejected",
      url: process.env.REACT_APP_API_TODO_LIST_ENDPOINT,
      accessToken: localStorage.getItem("AccessToken") || "llll",
    };

    const leadMapping: Record<
      LEAD_TYPE_PATHS,
      { params: any; getLeadFunction: Function }
    > = {
      [LEAD_TYPE_PATHS.AllLeads]: {
        params: defaultParams,
        getLeadFunction: getAllLeads,
      },
      [LEAD_TYPE_PATHS.HotLeads]: {
        params: { ...defaultParams, leadType: "HighIntent" },
        getLeadFunction: getHotLeads,
      },
      [LEAD_TYPE_PATHS.WarmLeads]: {
        params: { ...defaultParams, leadType: "MediumIntent" },
        getLeadFunction: getWarmLeads,
      },
      [LEAD_TYPE_PATHS.InterestedLeads]: {
        params: { ...defaultParams, leadType: "LowIntent" },
        getLeadFunction: getInterestedLeads,
      },
    };

    const { params: finalParams, getLeadFunction } =
      leadMapping[path] || leadMapping[LEAD_TYPE_PATHS.AllLeads];

    handleDeleteCardService(
      selectedLead,
      finalParams,
      setIsLoading,
      dispatch,
      addAlert,
      true,
      navigate,
      getLeadFunction,
      protectedResources
    );
  };

  return { handleConfirm };
};
